var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"supply_topic_btn"},[_c('div',{staticClass:"btn_wrap",class:_vm.tabName=='supply'?'supply_wrap':'topic_wrap'},[(_vm.tabName=='supply')?_c('img',{attrs:{"src":require("@/assets/img/new/supply_ic.png")},on:{"click":_vm.goTo}}):_c('img',{attrs:{"src":require("@/assets/img/new/topic_ic.png")},on:{"click":_vm.goTo}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }